import request from '@/utils/request'

const api_name = '/portal/web/api/schoolStation'

export default {
    submitApply(formData) {
        return request({
            url: api_name + '/submit',
            method: 'post',
            data: formData
        })
    },
    checkSchoolName(schoolName) {
        return request({
            url: api_name + '/checkName?schoolName=' + schoolName,
            method: 'get'
        })
    }
}
